import React, { useMemo, memo } from 'react';
import { ReactComponent as Confirmed } from '../../assets/images/badge-confirmed.svg';
import { ReactComponent as Guaranteed } from '../../assets/images/badge-guaranteed.svg';
import { ReactComponent as Bundle } from '../../assets/images/badge-bundle.svg';
import { ReactComponent as OnCall } from '../../assets/images/badge-on-call.svg';
import { ReactComponent as MarkedAsCalledBack } from '../../assets/images/marked-as-callback-badge-icon.svg';
import { ReactComponent as CallbackShift } from '../../assets/images/callback-shift-badge-icon.svg';
import { ReactComponent as Orientation } from '../../assets/images/badge-orientation.svg';
import { ReactComponent as Integrated } from '../../assets/images/badge-integrated.svg';
import ArrowSplitIcon from '../../assets/images/arrow-split-gray.svg';
import SplitShiftDetailsOverlay from '../shifts/SplitShift/SplitShiftDetailsOverlay';
import SLOT_STATUSES from '../../constants/slotStatuses';
import { GLOBAL_CALENDAR_SHIFT_TYPES, INTEGRATION_SOURCES } from '../../constants';
import Tooltip from '../../components/Tooltip/Tooltip';

import './SlotBadges.scss';

const SlotBadges = ({ shift, slot }) => {
	const shouldShowIntegratedBadge = () => {
		if (!slot.is_integrated) return false;
		if (slot.partner_name === 'Presbyterian' || slot.has_facility_mapping_integrated) return true;

		return (
			slot.integration_source_type_code === INTEGRATION_SOURCES.API &&
			(slot.caregiver_id === null || slot.has_assigned_slot_integrated)
		);
	};

	const shouldShowBadges = useMemo(
		() =>
			slot.slot_status === SLOT_STATUSES.CONFIRMED_SHIFT ||
			!!slot.is_guaranteed ||
			!!slot.contract_id ||
			!!shift.is_orientation ||
			!!slot.is_integrated ||
			!!shift.is_on_call,
		[shift, slot]
	);

	// if on-call slot is not marked as called back, we show the on-call badge
	const isOnCall = !!shift.is_on_call && slot.is_on_call && !slot.marked_as_callback;
	// if on-call slot is marked as called back, we show the marked as called back badge
	const isMarkedAsCalledBack = !!shift.is_on_call && slot.is_on_call && slot.marked_as_callback;
	// if slot is callback, we show the callback badge
	const isCallback = !!shift.is_on_call && !!slot.on_call_slot_id;

	return (
		shouldShowBadges && (
			<div className="slot-badges__container">
				<div className="slot-badges__left">
					{slot.slot_status === SLOT_STATUSES.CONFIRMED_SHIFT && shift.shift_type !== GLOBAL_CALENDAR_SHIFT_TYPES.FLEX && (
						<Tooltip label="Confirmed" placement="top">
							<Confirmed width={14} height={14} />
						</Tooltip>
					)}
				</div>
				<div className="slot-badges__right">
					{!!slot.has_segments && (
						<SplitShiftDetailsOverlay
							slotId={slot.slot_id}
							managementCompanyId={slot.management_company_id}
							triggerClassName="slot-badges__split"
							segmentsCount={slot.segments_count}
						>
							<img src={ArrowSplitIcon} alt="Show Segments" />
							{/* <ArrowSplitIcon width={14} height={14} /> */}
						</SplitShiftDetailsOverlay>
					)}
					{!!shift.is_orientation && (
						<Tooltip label="Orientation" placement="top">
							<Orientation />
						</Tooltip>
					)}
					{shouldShowIntegratedBadge() && (
						<Tooltip label="Integrated" placement="top">
							<Integrated />
						</Tooltip>
					)}
					{!!slot.contract_id && (
						<Tooltip label="Bundle" placement="top">
							<Bundle />
						</Tooltip>
					)}
					{isOnCall && (
						<Tooltip label="On Call shift" placement="top">
							<OnCall width={14} height={14} />
						</Tooltip>
					)}
					{isMarkedAsCalledBack && (
						<Tooltip label="Marked as Called Back" placement="top">
							<MarkedAsCalledBack width={14} height={14} className="gs-marked-as-called-back-badge" />
						</Tooltip>
					)}
					{isCallback && (
						<Tooltip label="Callback shift" placement="top">
							<CallbackShift width={14} height={14} className="gs-callback-shift-badge" />
						</Tooltip>
					)}
					{!!slot.is_guaranteed && (
						<Tooltip label="Guaranteed" placement="top">
							<Guaranteed />
						</Tooltip>
					)}
				</div>
			</div>
		)
	);
};

export default memo(SlotBadges);
